﻿import React from 'react';
import {Grid} from "@mui/material";

type CardBodyContainerProps = React.ComponentPropsWithoutRef<'div'>

/**
 * MUI Grid component styled in the SecurSpace way. Used in the main Container after the HeaderContainer to hold
 * label-value pairs in the body
 * @param children children passed through to the internal Grid component
 * @param rest The rest of the Grid props that will be passed through to the internal Grid component
 * @constructor
 */
const CardBodyContainer = ({ children, ...rest}: CardBodyContainerProps) => {
  return <Grid spacing={2} container alignItems={'center'} marginTop={'0.2em'} {...rest}>
    { children }
  </Grid>
}

export { CardBodyContainer };
